import { z } from 'zod';
const closeMissionParamsSchema = z.object({
    missionId: z.string().uuid(),
    missionTypeId: z.string().uuid(),
});
export const closeMissionFunctionDef = {
    name: 'closeMission',
    requestSchema: closeMissionParamsSchema,
    responseSchema: z.void(),
};
